import BaseNMComAdapter from './base.nmcom.adapter';

export default class LeadAdapter extends BaseNMComAdapter {
  static standardizeOptions(object, options = {}) {
    options.baseUrl = options.baseUrl || '<%=leadApiBaseUrl%>';
    return super.standardizeOptions(object, options);
  }
}
